"use client";
import BlogAreaCard from "@/components/common/blog-area-card";
import { getAllBlogsClient } from "@/lib/blog-data";

const MoreArticle = ({ currentSlug }: { currentSlug: string }) => {
    const blogs = getAllBlogsClient();
    
    // Convert blog data to the format expected by BlogAreaCard
    const blogCards = blogs.filter(blog => blog.slug !== currentSlug).map(blog => ({
        title: blog.title,
        date: blog.date || new Date().toISOString().split('T')[0],
        imageUrl: "/images/blog/blog-thumb-1.png", // Default image
        slug: blog.slug,
        url: `/blog/${blog.slug}`,
        tag: blog.tags[0] || "General",
        description: blog.short_description,
        author: blog.author
    }));

    return (
        <>
            <section className="desilo-blog-section overflow-hidden">
                <div className="container custom-container">
                    <div className="row">
                        <div className="col-12">
                            <div className="desilo__header text-center text-md-start row-padding-bottom">
                                <h2 className="title">
                                    More articles
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-4 gy-5">
                        {/* blog card start */}
                        {blogCards.slice(0, 3).map((item, i) => {
                            return (
                                <div key={i} className="col-md-6 col-lg-4">
                                    <BlogAreaCard data={item} />
                                </div>
                            );
                        })}
                        {/* blog card end */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default MoreArticle;
